/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Uploading_FileInputs */



/**
* | output |
* | --- |
* | "Uploading file..." |
*
* @param {Ateliere_Connect_Status_Uploading_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_uploading_file = /** @type {((inputs?: Ateliere_Connect_Status_Uploading_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Uploading_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléversement du fichier...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei wird hochgeladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento file in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка файла...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subiendo archivo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件正在上传……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルをアップロードしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल अपलोड हो रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enviando arquivo...")
	return /** @type {LocalizedString} */ ("Uploading file...")
});